<div
  class="upload-container"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
>
  <input type="file" (change)="onFileSelected($event)" hidden #fileInput />
  <button type="button" (click)="fileInput.click()">Select Document</button>
  <p>or drag and drop the document here</p>
  <p *ngIf="file">Selected file: {{ file.name }}</p>
</div>
